export default __webpack_public_path__ + "static/media/MishtiTakyonLightMini.db0bbf53.png";